export function toggleMobileSubmenu() {
  const menuItems = document.querySelectorAll(
    "#menu-menyu-v-shapke > .menu-item"
  );

  if (!menuItems.length) return;

  menuItems.forEach(item => {
    item.addEventListener("click", toggleSubmenu);
  });

  function toggleSubmenu(event) {
    if (window.innerWidth <= 1100) {
      const menuItem = event.currentTarget;

      const submenu = menuItem.querySelector(".header__submenu");

      if (submenu) {
        menuItem.classList.toggle("active");
      }
    }
  }

  window.addEventListener("resize", handleResize);

  function handleResize() {
    if (window.innerWidth > 1100) {
      menuItems.forEach(item => {
        const submenu = item.querySelector(".header__submenu");

        if (submenu) {
          item.classList.remove("active");

          submenu.style.display = "";
        }
      });
    }
  }
}
